export const reportList = state => state.list;
export const reportPage = state => state.page;
export const reportExportLimit = state => state.reportExportLimit;
export const reportExportEmail = state => state.email;

export const groupedAnswers = () => (answers, stepId) =>
  answers.filter(answer => answer.step_id === stepId);



/** WEBPACK FOOTER **
 ** ./src/store/modules/report/tableData/getters.js
 **/